import { Component } from 'react';
import { connect } from 'react-redux';

import Icon from 'components/atoms/Icon';
import { Dispatch } from 'redux';
import { OpenModal, PortType, RootState, ToolTipType } from 'types';
import { MapControlsInterface } from 'types/functions';
import { checkDifferent, clone } from 'utils/formHandlers';
import { formatCoordinate } from 'utils/formatCoordinate';

interface CoordinateToolTipProps {
    toolTip: ToolTipType;
    //unused props
    port: PortType;
    dragging: string | null;
    updateDrawinglabel?: (id: string, name: string) => void;
    mode: string;
    openModelFunction: OpenModal;
    mapControls: MapControlsInterface;
}

interface CoordinateToolTipState {
    toolTip: ToolTipType | null;
    dragging: string | null;
    //unsed state and used in getDerivedStateFromProps
    loading: boolean;
}

class CoordinateToolTip extends Component<CoordinateToolTipProps, CoordinateToolTipState> {
    constructor(props: CoordinateToolTipProps) {
        super(props);
        this.state = {
            toolTip: clone(props.toolTip),
            loading: true,
            dragging: null,
        };
    }

    static getDerivedStateFromProps(props: CoordinateToolTipProps, state: CoordinateToolTipState) {
        if (checkDifferent(props.toolTip, state.toolTip) || checkDifferent(props.dragging, state.dragging)) {
            return {
                toolTip: clone(props.toolTip),
                loading: true,
                dragging: props.dragging,
            };
        }
        return null;
    }

    closeTooltip = async () => {
        switch (this.props.mode) {
            case 'search':
                await this.props.mapControls.chart?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.chart?.hideTooltipById(this.props.toolTip.uuid);
                break;
            case 'live':
            case 'time':
                await this.props.mapControls.time?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.time?.hideTooltipById(this.props.toolTip.uuid);
                break;
            case 'playback':
                await this.props.mapControls.playback?.removeDrawingToolTipById(this.props.toolTip.uuid);
                await this.props.mapControls.playback?.hideTooltipById(this.props.toolTip.uuid);
                break;

            default:
                break;
        }
    };

    updateLabelModel = () => {
        if (this.state.dragging !== null) {
            return;
        }
        this.props.openModelFunction(
            'labelDrawingModel',
            0,
            'medium',
            {
                id: this.state?.toolTip?.uuid,
                name: this.state?.toolTip?.data.name,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('labelDrawingModel');
                },
                onConfirm: (data) => {
                    //@ts-ignore
                    this.props.updateDrawinglabel(data.id, data.name);
                },
            },
            true
        );
    };

    render() {
        return (
            <div className="flex flex-col  min-w-32 relative overflow-hidden rounded-md">
                <div
                    onDoubleClick={this.updateLabelModel}
                    className="w-tooltip h-full absolute z-10"
                    id={`Drag-${this.state?.toolTip?.uuid}`}
                ></div>
                <div className="w-full flex flex-col p-2">
                    <div className="flex justify-between gap-x-2 items-start">
                        <div>
                            {this.state?.toolTip?.data.name && <div>{this.state?.toolTip?.data.name}</div>}
                            <div className="capitalize text-sm ">
                                {formatCoordinate([
                                    this.state?.toolTip?.data.longitude,
                                    this.state?.toolTip?.data.latitude,
                                ]).join(' , ')}
                            </div>
                        </div>
                        <div
                            data-close="true"
                            onClick={this.closeTooltip}
                            className="flex justify-center items-end  justify-items-end cursor-pointer"
                        >
                            <Icon className="w-4 h-4">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M18 6l-12 12"></path>
                                <path d="M6 6l12 12"></path>
                            </Icon>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const CoordinateToolTipStateToProps = (state: RootState) => ({
    port: state.port.port,
    mapControls: state.map.mapControls,
    mode: state.layout.mode,
    openModelFunction: state.layout.openModelFunction,
});

const CoordinateToolTipDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(CoordinateToolTipStateToProps, CoordinateToolTipDispatchToProps)(CoordinateToolTip);
